import { Box, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { elStyle } from '../common/ContractTableHandlerCss';
import { I18n } from 'aws-amplify';
import { CONTRACT_SCREEN_MANAGEMENT } from '@/common/constant/NormalContractManagementConstant';

function ChoosePaymentConfirm({ paymentMethod, setPaymentMethod }) {
    const radioBtn = [
        {
            label: I18n.get('LABEL-BANK-TRANSFER'),
            value: CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER,
            defaultChecked: paymentMethod == CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER,
            style: { paddingRight: '48px' }
        },
        /* 23/01/2024 Temporarily hidden because the credit card payment function has not yet been implemented */
        
        // {
        //     label: I18n.get('LABEL-CREDIT-CARD'),
        //     value: CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.CREDIT,
        //     defaultChecked: paymentMethod == CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.CREDIT
        // }
    ];

    const handleChoosePayment = e => {
        const val = e.target.value;
        setPaymentMethod(val);
    };

    return (
        <Box display="flex" flexDirection="column">
            <Box component="p" {...elStyle.total_price_label}>
                {I18n.get('LABEL-TITLE-PAYMENT-METHOD')}
            </Box>
            <RadioGroup row aria-label="" name="radio-buttons-group">
                <Box
                    display="flex"
                    p="0 16px 20px 12px"
                    borderBottom="#E3E5E8 solid 1px"
                    width="100%"
                >
                    {radioBtn.map(item => (
                        <FormControlLabel
                            key={item.label}
                            className="tag-item custom-radio"
                            value={item.value}
                            control={<Radio checked={item.defaultChecked} />}
                            label={item.label}
                            style={item?.style}
                            onClick={e => handleChoosePayment(e)}
                        />
                    ))}
                </Box>
            </RadioGroup>
        </Box>
    );
}

export default ChoosePaymentConfirm;
